import './App.css'
import Navbar from './Navbar/Navbar';
import Home from './HomePage/Home';
import About from './About/About';
import Skills from './Skills/Skills';
import Projects from './projects-work/Projects';
import Footer from './footer/Footer';
import Article from './ArticleSection/articles';


function App() {

  return (
    <>

      <Navbar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Article />
      <Footer />

    </>
  );
}

export default App;
